import HCLDX from "@system/config/hcldx";
import Helper from "../../src/support/Helper";

class ProductCompare {
    static PRODUCT_COMPARE_SAVE = Helper.getProductUrl() + '/api/product/saveCompare';
    static PRODUCT_COMPARE_CLEAR_ALL = Helper.getProductUrl() + '/api/product/clearCompare';
    static PRODUCT_COMPARE_GET_ALL = Helper.getProductUrl() + '/api/product/getCompare';

    static getProductComparePageRouteURL() {
        return HCLDX.baseURL() + '/products/product-compare';
    }
}

export default ProductCompare;